import { all, call, put, select, takeLeading } from 'redux-saga/effects';
import { fetchCartStatus } from 'b2b-apps/shop/cart/redux/cartStatus/actionCreators';
import { Checkout } from 'b2b-apps/shop/checkout/api/Checkout';
import { Order } from 'b2b-apps/shop/checkout/api/Order';
import { clearCheckout, updateCheckout } from 'b2b-apps/shop/checkout/redux/checkout/actionCreators';
import { updateCheckoutSaga } from 'b2b-apps/shop/checkout/redux/checkout/sagas';
import { getCheckout, getRequestData } from 'b2b-apps/shop/checkout/redux/checkout/selectors';
import { placeOrderFulfilled, placeOrderRejected } from 'b2b-apps/shop/checkout/redux/order/actionCreators';
import { PLACE_ORDER } from 'b2b-apps/shop/checkout/redux/order/actionTypes';
import { PlaceOrderAction } from 'b2b-apps/shop/checkout/redux/order/types';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { getProfile } from 'b2b-apps/shop/context/redux/selectors';
import { getAbsoluteUrl } from 'b2b-apps/shop/routes/utils/url';

function* processPayment(checkoutId: string): Generator<any, any, any> {
  const callbackUrls = {
    success: getAbsoluteUrl('checkout/payment/success'),
    cancel: getAbsoluteUrl('checkout/payment/cancel'),
    error: getAbsoluteUrl('checkout/payment/error'),
  };

  const response = yield call(
    requestApiSaga,
    Checkout.datatransInit(checkoutId, callbackUrls),
  );

  window.location.replace(response?.data?.redirectUrl);
}

function* placeOrderSaga(action: PlaceOrderAction): Generator<any, any, any> {
  const checkoutData = yield select(getCheckout);

  if (!checkoutData.isLoaded) {
    return;
  }

  const { data: { payment, token } } = checkoutData;
  const { checkoutId } = action.payload;

  if (payment.isDatatrans) {
    yield call(processPayment, token);

    return;
  }

  const requestData = yield select(getRequestData);
  const loggedUserProfile = yield select(getProfile);

  try {
    if (requestData && !requestData.reference && loggedUserProfile?.email) {
      yield call(
        updateCheckoutSaga,
        updateCheckout(
          checkoutId, {
            ...requestData,
            reference: loggedUserProfile.email,
          },
        ),
      );
    }

    const response = yield call(requestApiSaga, Order.place(checkoutId));

    yield put(placeOrderFulfilled(checkoutId, response.data));
    yield put(fetchCartStatus());
    yield put(clearCheckout());
  } catch (error: any) {
    yield put(placeOrderRejected(checkoutId, parseError(error)));
    yield put(
      reportError(action.type, error, {
        checkoutId,
      }),
    );
  }
}

function* orderSaga(): Generator<any, any, any> {
  yield all([takeLeading(PLACE_ORDER, placeOrderSaga)]);
}

export {
  orderSaga,
  placeOrderSaga,
  processPayment,
};
